const receitasChart1 = {
    series: [{
        name: 'Cancelado',
        data: [0, 0, 0, 4, 0, 0, 1, 1, 0]
    },
        {
            name: 'Quitado',
            data: [45, 44, 10, 1, 40, 32, 1, 18, 1]
        }],
    chartOptions: {
        chart: {
            stacked: false,
            toolbar: {
                show: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 2,
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '20%',
                endingShape: 'rounded'
            }
        },
        colors: ['#e65566', '#34c38f'],
        fill: {
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['00099', '00001', '00005', '00088', '00044', '00008', '000888', '000887', '00002'],
        markers: {
            size: 0
        },
        yaxis: {
            min: 0
        },
    }
};



const receitasChart2 = {
    series: [1, 10, 61, 1],
    chartOptions: {
        plotOptions: {
            radialBar: {
                dataLabels: {
                    name: {
                        fontSize: '22px',
                    },
                    value: {
                        fontSize: '16px',
                    },
                    total: {
                        show: true,
                        label: 'Total',
                        // eslint-disable-next-line no-unused-vars
                        formatter: function (w) {
                            // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                            return 249
                        }
                    }
                }
            }
        },
        labels: ['00099', '00055', '00001', '999999'],
        colors: ['#556ee6', '#34c38f', '#f46a6a', '#f1b44c'],
    }
};





const despesasChart1 = {
    series: [{
        name: 'Cancelado',
        data: [1, 2, 0, 4, 0, 1, 4, 0, 1]
    },
        {
            name: 'Quitado',
            data: [23, 11, 22, 27, 13, 22, 52, 21, 44]
        }],
    chartOptions: {
        chart: {
            stacked: false,
            toolbar: {
                show: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 2,
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '20%',
                endingShape: 'rounded'
            }
        },
        colors: ['#e65566', '#34c38f'],
        fill: {
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['00099', '00001', '00005', '00088', '00044', '00008', '000888', '000887', '00002'],
        markers: {
            size: 0
        },
        yaxis: {
            min: 0
        },
    }
};



const despesasChart2 = {
    series: [44, 55, 67, 83],
    chartOptions: {
        plotOptions: {
            radialBar: {
                dataLabels: {
                    name: {
                        fontSize: '22px',
                    },
                    value: {
                        fontSize: '16px',
                    },
                    total: {
                        show: true,
                        label: 'Total',
                        // eslint-disable-next-line no-unused-vars
                        formatter: function (w) {
                            // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                            return 249
                        }
                    }
                }
            }
        },
        labels: ['00099', '00055', '00001', '999999'],
        colors: ['#556ee6', '#34c38f', '#f46a6a', '#f1b44c'],
    }
};




const usuariosChart1 = {
    series: [{
        name: 'Orçamentos',
        type: 'bar',
        data: [23, 11, 22, 27, 13, 22, 52, 21, 44]
    },
        {
            name: 'Pedidos',
            type: 'bar',
            data: [23, 11, 34, 27, 17, 22, 62, 32, 44]
        }],
    chartOptions: {
        chart: {
            stacked: false,
            toolbar: {
                show: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 2,
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '20%',
                endingShape: 'rounded'
            }
        },
        colors: ['#556ee6', '#34c38f'],
        fill: {
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['00099', '00001', '00005', '00088', '00044', '00008', '000888', '000887', '00002'],
        markers: {
            size: 0
        },
        yaxis: {
            min: 0
        },
    }
};



const usuariosChart2 = {
    series: [44, 55, 67, 83],
    chartOptions: {
        plotOptions: {
            radialBar: {
                dataLabels: {
                    name: {
                        fontSize: '22px',
                    },
                    value: {
                        fontSize: '16px',
                    },
                    total: {
                        show: true,
                        label: 'Total',
                        // eslint-disable-next-line no-unused-vars
                        formatter: function (w) {
                            // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                            return 249
                        }
                    }
                }
            }
        },
        labels: ['Time 001', 'Time 088', 'Time 005', 'Time 999'],
        colors: ['#556ee6', '#34c38f', '#f46a6a', '#f1b44c'],
    }
};



const representantesChart2 = {

    series: [{
        name: '0099',
        data: [46, 57, 59, 54, 62, 58, 64, 60, 66]
    }, {
        name: '0002',
        data: [74, 83, 102, 97, 86, 106, 93, 114, 94]
    }, {
        name: '4422',
        data: [37, 42, 38, 26, 47, 50, 54, 55, 43]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '45%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        colors: ['#34c38f', '#556ee6', '#f46a6a'],
        xaxis: {
            categories: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
        },
        yaxis: {
            title: {
                text: 'Valor Pedido',
                style: {
                    fontWeight: '500',
                },
            },
        },
        grid: {
            borderColor: '#f1f1f1',
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return "R$ " + val
                }
            }
        }
    }

}



const representantesChart1 = {
    series: [
        {
            name: "0099",
            data: [26, 24, 32, 36, 33, 31, 33]
        },
        {
            name: "0088",
            data: [14, 11, 16, 12, 17, 13, 12]
        },
        {
            name: "0088",
            data: [40, 4, 1, 38, 38, 17, 9]
        }
    ],
    chartOptions: {
        chart: {
            height: 380,
            type: 'line',
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            }
        },
        colors: ['#556ee6', '#34c38f', '#e69655'],
        dataLabels: {
            enabled: false,
        },
        stroke: {
            width: [3, 3],
            curve: 'straight'
        },
        title: {
            // text: 'Average High & Low Temperature',
            align: 'left',
            style: {
                fontWeight: '500',
            },
        },
        grid: {
            row: {
                colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.2
            },
            borderColor: '#f1f1f1'
        },
        markers: {
            style: 'inverted',
            size: 6
        },
        xaxis: {
            categories: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul'],
            title: {
                text: 'Mês'
            }
        },
        yaxis: {
            title: {
                text: 'Valor Pedido'
            },
            min: 5,
            max: 40
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: -5
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                legend: {
                    show: false
                },
            }
        }],
    }
}


const condicoesChart2 = {

    series: [44, 55, 41, 17, 15],
    chartOptions: {
        labels: ["0099", "0088", "0004", "0087", "0005"],
        colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 240
                },
                legend: {
                    show: false
                },
            }
        }]
    }

}



const condicoesChart1 = {
    series: [{
        data: [380, 430, 450, 475, 550, 584, 780, 1100, 1220, 1365]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
            }
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#34c38f'],
        grid: {
            borderColor: '#f1f1f1',
        },
        xaxis: {
            categories: ['0099', '0004', '0097', '0001', '0077', '0044', '0001', '0055', '0087', '0003'],
        }
    }

}


const formasChart2 = {

    series: [10, 22, 88, 7, 55],
    chartOptions: {
        labels: ["0099", "0088", "0004", "0087", "0005"],
        colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 240
                },
                legend: {
                    show: false
                },
            }
        }]
    }

}



const formasChart1 = {
    series: [{
        data: [380, 430, 450, 475, 550, 584, 780, 1100, 1220, 1365]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#0d516c'],
        grid: {
            borderColor: '#f1f1f1',
        },
        xaxis: {
            categories: ['0099', '0004', '0097', '0001', '0077', '0044', '0001', '0055', '0087', '0003'],
        }
    }

}




const tiposOperaChart2 = {

    series: [{
        data: [380, 430, 450, 475, 550, 584]
    }],
    chartOptions: {
        labels: ["SK0003", "SK0002", "SK0001"],
        colors: [ "#e69655", "#f46a6a"],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 240
                },
                legend: {
                    show: false
                },
            }
        }]
    }

}



const tiposOperaChart1 = {
    series: [{
        data: [380, 430, 1]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: true,
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
            }
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#6c3d0d'],
        grid: {
            borderColor: '#f1f1f1',
        },
        xaxis: {
            categories: ['SK0001', 'SK0002', 'SK0003'],
        }
    }

}






const clientesChart2 = {

    series: [44, 55, 41, 17, 15],
    chartOptions: {
        labels: ["ES", "MG", "RJ", "SP", "RN"],
        colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 240
                },
                legend: {
                    show: false
                },
            }
        }]
    }

}



const clientesChart1 = {
    series: [{
        data: [380, 430, 450, 475, 550, 584, 780, 1100, 1220, 1365]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
            }
        },
        dataLabels: {
            enabled: false
        },
        colors: ['#34c38f'],
        grid: {
            borderColor: '#f1f1f1',
        },
        xaxis: {
            categories: ['0099', '0004', '0097', '0001', '0077', '0044', '0001', '0055', '0087', '0003'],
        }
    }

}


const produtosChart2 = {

    series: [{
        name: 'Produto Testes 001',
        data: generateDayWiseTimeSeries(new Date('11 Feb 2023 GMT').getTime(), 20, {
            min: 10,
            max: 60
        })
    },
        {
            name: 'Produto Testes 099',
            data: generateDayWiseTimeSeries(new Date('11 Feb 2023 GMT').getTime(), 20, {
                min: 10,
                max: 60
            })
        },
        {
            name: 'Produto Testes 180',
            data: generateDayWiseTimeSeries(new Date('11 Feb 2023 GMT').getTime(), 30, {
                min: 10,
                max: 60
            })
        },
        {
            name: 'Produto Testes 005',
            data: generateDayWiseTimeSeries(new Date('11 Feb 2023 GMT').getTime(), 10, {
                min: 10,
                max: 60
            })
        },
    ],
    chartOptions: {
        chart: {
            height: 350,
            type: 'scatter',
            zoom: {
                type: 'xy'
            }
        },
        dataLabels: {
            enabled: false
        },
        grid: {
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            },
        },
        xaxis: {
            type: 'datetime',
        },
        yaxis: {
            max: 70
        }
    },

}


const produtosChart1 = {

    series: [{
        name: 'Grupo Testes 020',
        data: [46, 57, 59, 54, 62, 58, 64, 60, 66]
    }, {
        name: 'Grupo Testes 099',
        data: [74, 83, 102, 97, 86, 106, 93, 114, 94]
    }, {
        name: 'Grupo Testes 004',
        data: [37, 42, 38, 26, 47, 50, 54, 55, 43]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '45%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        colors: ['#34c38f', '#556ee6', '#f46a6a'],
        xaxis: {
            categories: ['Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out'],
        },
        yaxis: {
            title: {
                text: '$ (thousands)',
                style: {
                    fontWeight: '500',
                },
            },
        },
        grid: {
            borderColor: '#f1f1f1',
        },
        fill: {
            opacity: 1
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return "$ " + val + " thousands"
                }
            }
        }
    }

};



const pedidosChart2 = {

    series: [44, 55, 41, 17, 15],
    chartOptions: {
        labels: ["Repres Testes 001", "Repres Testes 005", "Repres Testes 099", "Repres Testes 557", "Repres Testes 011"],
        colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
        legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            verticalAlign: 'middle',
            floating: false,
            fontSize: '14px',
            offsetX: 0
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    height: 240
                },
                legend: {
                    show: false
                },
            }
        }]
    }

}

const pedidosChart1 = {

    series: [{
        name: 'Grupo Testes 001',
        type: 'column',
        data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30]
    }, {
        name: 'Grupo Testes 998',
        type: 'area',
        data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43]
    }, {
        name: 'Grupo Testes 005',
        type: 'line',
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39]
    }],
    chartOptions: {
        chart: {
            stacked: false,
            toolbar: {
                show: false
            }
        },
        stroke: {
            width: [0, 2, 4],
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '50%'
            }
        },
        colors: ['#f46a6a', '#556ee6', '#34c38f'],
        fill: {
            opacity: [0.85, 0.25, 1],
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['01/01/2003', '02/01/2003', '03/01/2003', '04/01/2003', '05/01/2003', '06/01/2003', '07/01/2003', '08/01/2003', '09/01/2003', '10/01/2003', '11/01/2003'],
        markers: {
            size: 0
        },
        xaxis: {
            type: 'datetime'
        },
        yaxis: {
            title: {
                text: 'Pedidos',
            },
        },
        tooltip: {
            shared: true,
            intersect: false,
            y: {
                formatter: function (y) {
                    if (typeof y !== "undefined") {
                        return y.toFixed(0) + " points";
                    }
                    return y;

                }
            }
        },
        grid: {
            borderColor: '#f1f1f1'
        }
    }
}




const orcamentosChart1 = {
    series: [{
        name: 'Faturados',
        type: 'column',
        data: [23, 11, 22, 27, 13, 22, 52, 21, 44, 22, 30]
    },
        {
            name: 'Todos',
            type: 'line',
            data: [23, 11, 34, 27, 17, 22, 62, 32, 44, 22, 39]
        }],
    chartOptions: {
        chart: {
            stacked: false,
            toolbar: {
                show: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 2,
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '20%',
                endingShape: 'rounded'
            }
        },
        colors: ['#34c38f', '#556ee6'],
        fill: {
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Mai', 'Nov'],
        markers: {
            size: 0
        },
        yaxis: {
            min: 0
        },
    }
};



const orcamentosChart2 = {
    series: [44, 55, 67, 83],
    chartOptions: {
        plotOptions: {
            radialBar: {
                dataLabels: {
                    name: {
                        fontSize: '22px',
                    },
                    value: {
                        fontSize: '16px',
                    },
                    total: {
                        show: true,
                        label: 'Total',
                        // eslint-disable-next-line no-unused-vars
                        formatter: function (w) {
                            // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                            return 249
                        }
                    }
                }
            }
        },
        labels: ['Grupo Testes 001', 'Grupo Testes 088', 'Grupo Testes 005', 'Grupo Testes 999'],
        colors: ['#556ee6', '#34c38f', '#f46a6a', '#f1b44c'],
    }
};



const tasksChart = {
    series: [{
        name: 'Complete Tasks',
        type: 'column',
        data: [23, 11, 22, 27, 13, 22, 52, 21, 44, 22, 30]
    },
    {
        name: 'All Tasks',
        type: 'line',
        data: [23, 11, 34, 27, 17, 22, 62, 32, 44, 22, 39]
    }],
    chartOptions: {
        chart: {
            stacked: false,
            toolbar: {
                show: false,
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            width: 2,
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '20%',
                endingShape: 'rounded'
            }
        },
        colors: ['#556ee6', '#34c38f'],
        fill: {
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Mai', 'Nov'],
        markers: {
            size: 0
        },
        yaxis: {
            min: 0
        },
    }
};

const tasks = [
    {
        index: 1,
        taskType: 'upcoming',
        name: 'Create a Skote Dashboard UI',
        images: [require('@/assets/images/users/avatar-2.jpg'), require('@/assets/images/users/avatar-1.jpg')],
        status: 'Waiting',
        checked: false
    },
    {
        index: 2,
        taskType: 'upcoming',
        name: 'Create a New Landing UI',
        images: [require('@/assets/images/users/avatar-4.jpg'), require('@/assets/images/users/avatar-5.jpg')],
        status: 'Approved',
        checked: true
    },
    {
        index: 3,
        taskType: 'upcoming',
        name: 'Create a Skote Logo',
        images: [require('@/assets/images/users/avatar-1.jpg')],
        status: 'Waiting',
        checked: false
    },
    {
        index: 4,
        taskType: 'inprogress',
        name: 'Brand logo design',
        images: [require('@/assets/images/users/avatar-7.jpg')],
        status: 'Complete',
        checked: true
    },
    {
        index: 5,
        taskType: 'inprogress',
        name: 'Create a Blog Template UI',
        images: [require('@/assets/images/users/avatar-8.jpg'), require('@/assets/images/users/avatar-1.jpg')],
        status: 'Pending',
        checked: false
    },
    {
        index: 6,
        taskType: 'completed',
        name: 'Redesign - Landing page',
        images: [require('@/assets/images/users/avatar-6.jpg')],
        status: 'Complete',
        checked: false
    },
    {
        index: 7,
        taskType: 'completed',
        name: 'Multipurpose Landing',
        images: [require('@/assets/images/users/avatar-7.jpg')],
        status: 'Complete',
        checked: true
    },
    {
        index: 8,
        taskType: 'completed',
        name: 'Create a Blog Template UI',
        images: [require('@/assets/images/users/avatar-4.jpg'), require('@/assets/images/users/avatar-2.jpg')],
        status: 'Complete',
        checked: false
    }
];

const customersData = [
    {
        id: 1,
        username: 'Cliente Testes 0088',
        phone: '00.00000-0000',
        email: 'empresa@dominio.com.br',
        address: 'Rua Testes, SN, Centro',
        rating: '4.2',
        balance: '5.412',
        date: '07 Mai, 2023'
    },
    {
        id: 2,
        username: 'Cliente Testes 0090',
        phone: '00.00000-0000',
        email: 'empresa@dominio.com.br',
        address: 'Rua Testes, SN, Centro',
        rating: '4.0',
        balance: '5.632',
        date: '06 Mai, 2023'
    },
    {
        id: 3,
        username: 'Cliente Testes 0001',
        phone: '00.00000-0000',
        email: 'empresa@dominio.com.br',
        address: 'Rua Testes, SN, Centro',
        rating: '4.4',
        balance: '7.523',
        date: '06 Mai, 2023'
    },
    {
        id: 4,
        username: 'Cliente Testes 0057',
        phone: '00.00000-0000',
        email: 'empresa@dominio.com.br',
        address: 'Rua Testes, SN, Centro',
        rating: '4.1',
        balance: '6.325',
        date: '05 Mai, 2023'
    },
    {
        id: 5,
        username: 'Cliente Testes 0087',
        phone: '00.00000-0000',
        email: 'empresa@dominio.com.br',
        address: 'Rua Testes, SN, Centro',
        rating: '3.8',
        balance: '4.523',
        date: '04 Mai, 2023'
    },
    {
        id: 6,
        username: 'Cliente Testes 0004',
        phone: '00.00000-0000',
        email: 'empresa@dominio.com.br',
        address: 'Rua Testes, SN, Centro',
        rating: '4.0',
        balance: '5.412',
        date: '03 Mai, 2023'
    },
    {
        id: 7,
        username: 'Cliente Testes 0900',
        phone: '00.00000-0000',
        email: 'empresa@dominio.com.br',
        address: 'Rua Testes, SN, Centro',
        rating: '4.2',
        balance: '6.180',
        date: '02 Mai, 2023'
    },
    {
        id: 8,
        username: 'Cliente Testes 0901',
        phone: '00.00000-0000',
        email: 'empresa@dominio.com.br',
        address: 'Rua Testes, SN, Centro',
        rating: '4.1',
        balance: '5.2870',
        date: '02 Mai, 2023'
    }
];

function generateDayWiseTimeSeries(baseval, count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
        var x = baseval;
        var y =
            Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

        series.push([x, y]);
        baseval += 86400000;
        i++;
    }
    return series;
}

export { tasksChart, tasks, orcamentosChart1, orcamentosChart2, pedidosChart1, pedidosChart2, customersData, produtosChart1, produtosChart2, clientesChart1, clientesChart2, condicoesChart1, condicoesChart2, usuariosChart1, usuariosChart2, formasChart1, formasChart2, tiposOperaChart1, tiposOperaChart2, representantesChart1, representantesChart2, despesasChart1, despesasChart2, receitasChart1, receitasChart2 };
